import bech32, { bech32m } from "./bech32_ln";

function convertBits(data, fromBits, toBits, pad) {
    let acc = 0;
    let bits = 0;
    const ret = [];
    const maxv = (1 << toBits) - 1;

    for (const value of data) {
        if (value < 0 || value >> fromBits !== 0) return null;

        acc = (acc << fromBits) | value;
        bits += fromBits;

        while (bits >= toBits) {
            bits -= toBits;
            ret.push((acc >> bits) & maxv);
        }
    }

    if (pad) {
        if (bits > 0) {
            ret.push((acc << (toBits - bits)) & maxv);
        }
    } else if (bits >= fromBits || ((acc << (toBits - bits)) & maxv)) {
        return null;
    }

    return ret;
}

function isValidSegwitAddress(address) {
    let dec;
    try {
        // Try decoding with bech32m first (Taproot and future versions)
        dec = bech32m.decode(address);
    } catch {
        try {
            // Fallback to bech32 (legacy SegWit)
            dec = bech32.decode(address);
        } catch {
            return false;
        }
    }

    const hrp = dec.prefix;
    const words = dec.words;

    if (hrp !== 'bc' && hrp !== 'tb') return false;
    if (!Array.isArray(words) || words.length < 1) return false;

    const version = words[0];
    const program = convertBits(words.slice(1), 5, 8, false);
    if (!program) return false;

    const length = program.length;

    // Check checksum rule: bech32m for v1+, bech32 for v0
    const expectedEncoding = version === 0 ? bech32 : bech32m;
    try {
        const reencoded = expectedEncoding.encode(hrp, words);
        if (reencoded.toLowerCase() !== address.toLowerCase()) {
            return false;
        }
    } catch {
        return false;
    }

    if (
        version === 0 && (length === 20 || length === 32) // P2WPKH or P2WSH
    ) {
        return true;
    }

    if (
        version >= 1 && version <= 16 && length >= 2 && length <= 40 // Taproot or future
    ) {
        return true;
    }

    return false;
}

export default {
    isValidAddress: isValidSegwitAddress,
};